import React from 'react';

// タイマーを作った時点の条件を閉じ込めず、毎回最新の処理を呼び出す。
export const useInterval = (callback: () => void, delay: number | null) => {
  const callbackRef = React.useRef(callback);
  React.useEffect(() => { callbackRef.current = callback; }, [callback]);
  React.useEffect(() => {
    if (delay === null) return;
    const timer = setInterval(() => callbackRef.current(), delay);
    return () => clearInterval(timer);
  }, [delay]);
};
